@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: dark from "../../styles/theming.module.css";
}

.media {
    &::after {
        content: "";
        position: absolute;
        inset: 0;
        background-color: rgb(var(--black-base) / 45%);
    }
}

.cta {
    margin-top: var(--spacer-24);
}

.modal {
    position: fixed;
    inset: 0;
    z-index: 100;
}

.dialog {
    composes: gridContainer from "../../styles/composable/layout.module.css";
    align-items: center;
    height: 100%;
}

.overlay {
    position: absolute;
    inset: 0;
    background-color: var(--black);
    z-index: 0;
}

.modalVideo {
    grid-column: 2 / span 10;
    z-index: 1;

    @media ($below-mobile) {
        grid-column: 1 / -1;
    }
}

.content {
    padding-block: var(--spacer-32);
}
